import { defineComponent as _defineComponent } from 'vue'
import { useAuth } from '@/logics/useAuth'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  name: 'LoginPage',
  setup(__props, { expose }) {
  expose();

const {login, loginWithGoogle} = useAuth()
const isLoading = ref(false)

const doLogin = () => {
  isLoading.value = true
  login().finally(() => (isLoading.value = false))
}

const doLoginWithGoogle = async () => {
  isLoading.value = true
  loginWithGoogle().finally(() => (isLoading.value = false))
}

const __returned__ = { login, loginWithGoogle, isLoading, doLogin, doLoginWithGoogle }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})